import { SOURCES, type SourceKey } from '../daily-sales-format';

export function DailySalesLegend({ sources }: { sources: SourceKey[] }) {
  return (
    <div className="nb-ds-legend">
      {SOURCES.filter((s) => sources.includes(s.key)).map((s) => (
        <span key={s.key}>
          <i className="nb-ds-swatch" style={{ background: s.color }} />
          {s.name}
        </span>
      ))}
    </div>
  );
}
